import { Box } from '@mui/material'
import { AllocationRuleDto } from '@yard/app/api'
import { RuleCapacity } from '@yard/utils/allocation-rule-capacity.util'
import { observer } from 'mobx-react-lite'
import { Draggable } from 'react-beautiful-dnd'
import { AssignedAllocationRule } from './AssignedAllocationRule'

interface droppableProps {
  allocationRule: AllocationRuleDto
  capacityByRule?: Record<string, RuleCapacity>
  matchingCountByRule?: Record<string, number>
  index: number
  isEditable?: boolean
  isSelected?: boolean
  onMouseOver: () => void
  onMouseLeave: () => void
  onEdit: () => void
  onDelete: () => void
}

export const AssignedDraggableAllocationRuleDraggable = observer(
  ({
    allocationRule,
    capacityByRule,
    matchingCountByRule,
    index,
    isEditable,
    isSelected,
    onMouseOver,
    onMouseLeave,
    onEdit,
    onDelete,
  }: droppableProps) => (
    <Draggable draggableId={`allocation-draggable-${index}`} index={index}>
      {provided => (
        <Box
          ref={provided.innerRef}
          {...provided.draggableProps}
          sx={{
            background: 'white',
          }}
        >
          <AssignedAllocationRule
            allocationRule={allocationRule}
            capacityByRule={capacityByRule}
            matchingCountByRule={matchingCountByRule}
            dragHandleProps={provided.dragHandleProps}
            isEditable={isEditable}
            isSelected={isSelected}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </Box>
      )}
    </Draggable>
  ),
)
